import AxiosService from '../AxiosService';

const GetUpdatedDebts = async (clientCode?: string) => {
  const instance = AxiosService.createProductsAxiosInstance();
  const response = await instance.get(
    `/client/sap/debts?client_code=${clientCode}`,
  );
  return response.data;
};

const GetPaymentMethods = async () => {
  const instance = AxiosService.createProductsAxiosInstance();
  const response = await instance.get('/payment-methods', {
    headers: {
      //
    },
  });

  return response.data;
};

const CreatePix = async (data: Object) => {
  const instance = AxiosService.createProductsAxiosInstance();
  const response = await instance.post('/iopay/pix', data);
  return response.data;
};

const CheckPixStatus = async (data: Object) => {
  try {
    const instance = AxiosService.createProductsAxiosInstance();
    const response = await instance.post(`/iopay/pix/order/check`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export default {
  GetUpdatedDebts,
  GetPaymentMethods,
  CreatePix,
  CheckPixStatus,
};
